<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { mapActions, mapGetters } from "vuex";
import Pagination from "../../../components/pagination.vue";
import formatter from "../../../mixins/formatter";
import Swal from "sweetalert2";

export default {
    page: {
        title: "Mobile Dashboard",
        meta: [{ name: "description", content: appConfig.description }],
    },
    components: { Layout, PageHeader, Pagination },
    mixins: [formatter],
    data() {
        return {
            title: "Mobile Dashboard",
            totalWingBand: null,
            showModal: false,
            loading: true,
            isImporting: false,
            data: {
                list: [],
                links: [],
                current_page: 1,
                per_page: 1,
                last_page: 1,
            },
            chapters: [],
            showChapterHint: false,
            form: {
                total: "",
                breeders: "",
                farm_name: "",
                farm_address: "",
                province: "",
                contact_number: "",
                stag_number: "",
                chapter_id: "",
            },
            errorMessage: "",
            filter: {
                search: "",
                limit: 10,
            },
            selectedFile: null,
            importModal: false,
            importErrors: [],
        };
    },
    computed: {
        ...mapGetters("auth", ["profile"]),
    },
    methods: {
        ...mapActions("wingband", {
            getList: "getList",
            importFile: "importWingband",
            archive: "update",
        }),
        filterData() {
            this.initList(1);
        },
        resetFilter() {
            this.filter.search = "";
            this.filter.limit = 10;
            this.initList(1);
        },
        async initList(p) {
            const pl = {
                page: p,
                limit: this.filter.limit,
                sort: "created_at",
                status: 1,
            };
            if (this.filter.search) pl.search = this.filter.search;
            this.loading = true;
            const data = await this.getList(pl);
            this.loading = false;
            this.data.list = data.data;
            this.totalWingBand = data.total;
            this.data.links = data.links;
            this.data.current_page = data.current_page;
            this.data.per_page = data.per_page;
            this.data.last_page = data.last_page;
        },
        async wingbandModal() {
            this.errorMessage = "";
            this.form = {
                total: "",
                breeders: "",
                farm_name: "",
                farm_address: "",
                province: "",
                contact_number: "",
                stag_number: "",
                chapter_id: "",
            };
            this.showModal = true;
        },
        closeModal() {
            this.showModal = false;
            this.importModal = false;
            this.importErrors = [];
            this.selectedFile = null;
        },
        goTo() {
            const f = this.form;
            if (!f.total || !f.breeders || !f.farm_name || !f.farm_address || !f.province || !f.contact_number || !f.stag_number || !f.chapter_id) {
                this.errorMessage = "Please fill in all required fields.";
                return;
            }
            this.errorMessage = "";
            this.showModal = false;
            let query = {
                total: f.total,
                breeders: f.breeders,
                farm_name: f.farm_name,
                farm_address: f.farm_address,
                province: f.province,
                contact_number: f.contact_number,
                stag_number: f.stag_number,
            }
         
            if(f.chapter_id) {
                const cid = Number(f.chapter_id);
                query.chapter_id = cid;
                query.chapter = this.chapters?.find(c => c.id === cid)?.chapter
                    || this.profile.chapters?.find(c => c.id === cid)?.chapter
                    || ""
            }

            this.$router.push({
                path: "/mobile-wingband",
                query: query,
            });
        },
        convertToCsv(objArray) {
            const array = typeof objArray !== "object" ? JSON.parse(objArray) : objArray;
            let str = "";
            for (let i = 0; i < array.length; i++) {
                let line = "";
                for (const index in array[i]) {
                    if (line !== "") line += ",";
                    line += array[i][index];
                }
                str += line + "\r\n";
            }
            return str;
        },
        exportCsvFile(headers, item, fileTitle) {
            if (headers) item.unshift(headers);
            const csv = this.convertToCsv(JSON.stringify(item));
            const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
            if (navigator.msSaveBlob) {
                navigator.msSaveBlob(blob, fileTitle + ".csv");
            } else {
                const link = document.createElement("a");
                if (link.download !== undefined) {
                    const url = URL.createObjectURL(blob);
                    link.setAttribute("href", url);
                    link.setAttribute("download", fileTitle + ".csv");
                    link.style.visibility = "hidden";
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                }
            }
        },
        exportData() {
            const current = new Date();
            const currentDate = `${current.getDate()}-${current.getMonth() + 1}-${current.getFullYear()}`;
            const headers = {
                stag_registry: "STAG REGISTRY NO.",
                breeder_name: "NAME OF BREEDERS",
                farm_name: "FARM NAME",
                farm_address: "FARM ADDRESS",
                province: "PROVINCE",
                wingband_no: "WINGBAND NO.",
                feather_color: "FEATHER COLOR",
                leg_color: "LEG COLOR",
                comb_shape: "COMB SHAPE",
                nose_markings: "NOSE MARKINGS",
                feet_markings: "FEET MARKINGS",
                date: "DATE",
            };
            const itemsFormatted = this.data.list.map((item) => ({
                stag_registry: item.stag_registry,
                breeder_name: item.breeder_name,
                farm_name: item.farm_name,
                farm_address: item.farm_address,
                province: item.province,
                wingband_no: item.wingband_number,
                feather_color: item.feather_color,
                leg_color: item.leg_color,
                comb_shape: item.comb_shape,
                nose_markings: item.nose_markings,
                feet_markings: item.feet_markings,
                date: item.wingband_date,
            }));
            this.exportCsvFile(headers, itemsFormatted, `Wingbands ${currentDate}`);
        },
        async importExcel() {
            if (!this.selectedFile) {
                Swal.fire({ icon: "error", title: "Failed!", text: "Please select a file first." });
                return;
            }
            if (this.isImporting) return;
            this.isImporting = true;
            this.importErrors = [];
            const formData = new FormData();
            formData.append("excel_file", this.selectedFile);
            try {
                const res = await this.importFile(formData);
                if (res.message === "Wingbands imported successfully please check the excel data uploaded to the system") {
                    Swal.fire({ icon: "success", title: "Import successful! Wait for a few seconds to check.", text: res.message, timer: 4000, timerProgressBar: true });
                    this.importModal = false;
                    this.initList();
                } else if (res.status === "error" && res.errors && res.errors.length > 0) {
                    this.importErrors = res.errors;
                } else {
                    Swal.fire({ icon: "error", title: "Failed!", text: res.message });
                }
            } catch (error) {
                console.error("Error uploading file:", error);
            } finally {
                this.isImporting = false;
            }
        },
        handleFileUpload(event) {
            this.selectedFile = event.target.files[0] || null;
        },
        openImportModal() {
            this.importModal = true;
        },
        async downloadTemplate() {
            const link = document.createElement("a");
            link.href = "/Template.xlsx";
            link.download = "Wingband_Import_Template.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        async addArchive(id) {
            const confirmed = await Swal.fire({
                title: "Are you sure?",
                text: "Do you want to archive this record?",
                icon: "warning",
                showCancelButton: true,
                padding: "2em",
            }).then((r) => r.isConfirmed);
            if (confirmed) {
                const res = await this.archive({ id, status: 2 });
                if (res.message === "Wingband archived successfully.") {
                    Swal.fire({ icon: "success", title: "Archived successfully", text: res.message, timer: 2000, timerProgressBar: true });
                    this.initList();
                } else {
                    Swal.fire({ icon: "error", title: "Failed!", text: res.message });
                }
            }
        },
        async populateChapters() {
            const res = await this.$store.dispatch("chapter/getAll", { limit: 200 });
            this.chapters = (res?.data?.data && Array.isArray(res.data.data))
                ? res.data.data
                : (Array.isArray(res?.data) ? res.data : []);

        },
    },
    watch: {
        importModal(val) {
            if (!val) {
                this.importErrors = [];
                this.selectedFile = null;
                this.errorMessage = "";
                this.showChapterHint = false;
                if (this.$refs.fileInput) this.$refs.fileInput.value = "";
            }
        },
    },
    mounted() {
        this.initList(1);
        this.populateChapters();
    },
};
</script>

<template>
    <Layout>
        <PageHeader :title="title">
            <button class="btn btn-info text-white" @click="$refreshPage()"><i class='bx bx-refresh'></i> Refresh</button>
        </PageHeader>
        
        <!-- User Info + Start Wingbanding -->
        <div class="row mb-3 g-3">
            <div class="col-12 col-md-8">
                <div class="card h-100 mb-0">
                    <div class="card-body cust-padding">
                        <h5 class="mb-2 fw-bolder">User Information</h5>
                        <hr class="mt-1">
                        <div class="row g-2">
                            <div class="col-6">
                                <div class="d-flex gap-2 flex-wrap">
                                    <span class="fw-bold">NAME:</span>
                                    <span class="text-dark">{{ profile.username }}</span>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="d-flex gap-2 flex-wrap">
                                    <span class="fw-bold">CONTACT #:</span>
                                    <span class="text-dark">{{ profile.contact_number }}</span>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="d-flex gap-2 flex-wrap">
                                    <span class="fw-bold">ROLE/TITLE:</span>
                                    <span class="text-dark">
                                        <span v-if="profile.role == 'admin'">Admin</span>
                                        <span v-else-if="profile.role == 'encoder'">Encoder</span>
                                        <span v-else>Viewer</span>
                                    </span>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="d-flex gap-2 flex-wrap">
                                    <span class="fw-bold">REGISTRY DATE:</span>
                                    <span class="text-dark">{{ dateTime(profile.created_at) }}</span>
                                </div>
                            </div>
                            <div class="col-6" v-if="profile.role == 'encoder'">
                                <div class="d-flex gap-2 flex-wrap">
                                    <span class="fw-bold">TOTAL WINGBAND:</span>
                                    <span class="text-dark">{{ totalWingBand ? totalWingBand : '-' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-4" v-if="profile.role == 'encoder'">
                <div class="card disflex bg-green act-btn h-100 mb-0" style="min-height: 80px;" @click="wingbandModal">
                    <p class="fw-bolder fs-4 text-white m-0 p-0 text-center">START WINGBANDING</p>
                </div>
            </div>
        </div>

        <!-- Filter + Action Buttons -->
        <div class="card mb-3">
            <div class="card-body p-2">
                <div class="row g-2 align-items-center">
                    <div class="col-12 col-sm-auto flex-grow-1">
                        <div class="d-flex gap-2 flex-wrap align-items-center">
                            <input class="form-control" style="max-width: 220px;" type="text"
                                v-model="filter.search" placeholder="Search..." @keyup.enter="filterData()">
                            <button class="btn btn-success" @click="filterData()">Search</button>
                            <button class="btn btn-secondary" @click="resetFilter()">Reset</button>
                            
                            <select class="form-control" style="width: 90px;" v-model="filter.limit" @change="filterData()">
                                <option value="10">10</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                                <option value="200">200</option>
                                <option value="500">500</option>
                            </select>
                        </div>
                    </div>
                    <div class="col-12 col-sm-auto d-flex gap-2 flex-wrap">
                        <button class="btn btn-light disflex" @click="exportData()"
                            v-if="profile.role != 'encoder'">
                            <i class='bx bx-export fs-5'></i> Export
                        </button>
                        <button class="btn btn-primary disflex" @click="downloadTemplate()"
                            v-if="profile.role == 'encoder'">
                            <i class='bx bx-download fs-5'></i> Template
                        </button>
                        <button class="btn btn-success disflex" @click="openImportModal()"
                            v-if="profile.role == 'encoder'">
                            <i class='bx bx-export fs-5'></i> Import
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Wingband Cards -->
        <div v-if="loading" class="text-center py-5">
            <div class="spinner-border text-primary" role="status"></div>
            <p class="mt-2 text-muted">Loading...</p>
        </div>
        <div v-else>
            <div class="row g-3" v-if="data.list && data.list.length > 0">
                <div class="col-12 col-md-6 col-xl-4" v-for="(item, index) in data.list" :key="index">
                    <div class="card h-100 mb-0 shadow-sm">
                        <div class="card-body">
                            <div class="d-flex justify-content-between align-items-start mb-2">
                                <h6 class="fw-bold mb-0 text-primary">WB# {{ item.wingband_number }}</h6>
                            </div>
                            <div class="row g-1 mb-2">
                                <div class="col-6">
                                    <p class="mb-0 small"><span class="fw-semibold">Breeder:</span> {{ item.breeder_name }}</p>
                                </div>
                                <div class="col-6">
                                    <p class="mb-0 small"><span class="fw-semibold">Farm:</span> {{ item.farm_name }}</p>
                                </div>
                                <div class="col-12">
                                    <p class="mb-0 small"><span class="fw-semibold">Address:</span> {{ item.farm_address }}</p>
                                </div>
                                <div class="col-6">
                                    <p class="mb-0 small"><span class="fw-semibold">Province:</span> {{ item.province }}</p>
                                </div>
                                <div class="col-6">
                                    <p class="mb-0 small"><span class="fw-semibold">Chapter:</span> {{ item.chapter }}</p>
                                </div>
                                <div class="col-6">
                                    <p class="mb-0 small"><span class="fw-semibold">Stag Registry:</span> {{ item.stag_registry }}</p>
                                </div>
                                <div class="col-6">
                                    <p class="mb-0 small"><span class="fw-semibold">Season:</span> {{ item.season_name }}</p>
                                </div>
                                <div class="col-12">
                                    <p class="mb-0 small"><span class="fw-semibold">Date:</span> {{ item.wingband_date }}</p>
                                </div>
                            </div>
                            <div class="d-flex flex-wrap gap-1 mb-2">
                                <span class="badge bg-light text-dark border small">{{ item.feather_color }}</span>
                                <span class="badge bg-light text-dark border small">{{ item.leg_color }}</span>
                                <span class="badge bg-light text-dark border small">{{ item.comb_shape }}</span>
                                <span class="badge bg-light text-dark border small">{{ item.nose_markings }}</span>
                                <span class="badge bg-light text-dark border small">{{ item.feet_markings }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="text-center py-5 text-muted">
                <i class="bx bx-data fs-1 d-block mb-2"></i>
                No wingband records found.
            </div>
            <Pagination :data="data" @emitPage="initList" class="mt-3 me-2" />
        </div>

        <!-- Wingband Modal -->
        <b-modal v-model="showModal" centered title="Wingband" title-class="font-18" hide-footer size="xl" dialog-class="modal-almost-fullscreen" no-close-on-backdrop no-close-on-esc>
            <div class="mb-3">
                <label class="form-label fw-semibold">Total Wingband:</label>
                <input class="form-control" type="number" v-model="form.total"
                    placeholder="Enter total of wingband...">
            </div>
            <div class="row g-3 mb-3">
                <div class="col-12 col-sm-6">
                    <label class="form-label fw-semibold">Name of Breeders:</label>
                    <input class="form-control" type="text" v-model="form.breeders"
                        placeholder="Enter name of breeders...">
                </div>
                <div class="col-12 col-sm-6">
                    <label class="form-label fw-semibold">Farm Name:</label>
                    <input class="form-control" type="text" v-model="form.farm_name"
                        placeholder="Enter farm name...">
                </div>
            </div>
            <div class="mb-3">
                <label class="form-label fw-semibold">Farm Address:</label>
                <input class="form-control" type="text" v-model="form.farm_address"
                    placeholder="Enter farm address...">
            </div>
            <div class="row g-3 mb-3">
                <div class="col-12 col-sm-6">
                    <label class="form-label fw-semibold">Province:</label>
                    <input class="form-control" type="text" v-model="form.province"
                        placeholder="Select province...">
                </div>
                <div class="col-12 col-sm-6">
                    <label class="form-label fw-semibold">Chapter:</label>
                    <!-- Encoder with assigned chapters: options limited to their assigned chapters -->
                    <select
                        v-if="profile.role === 'encoder' && profile.chapters && profile.chapters.length > 0"
                        class="form-control"
                        v-model="form.chapter_id"
                    >
                        <option value="">-- Select Chapter --</option>
                        <option v-for="c in profile.chapters" :key="c.id" :value="c.id">
                            {{ c.chapter }}
                        </option>
                    </select>
                    <!-- Admin or encoder without chapters: full chapter selection -->
                    <select v-else class="form-control" v-model="form.chapter_id">
                        <option value="">-- Select Chapter --</option>
                        <option v-for="c in chapters" :key="c.id" :value="c.id">
                            {{ c.chapter }}
                        </option>
                    </select>
                </div>
            </div>
            <div class="row g-3 mb-3">
                <div class="col-12 col-sm-6">
                    <label class="form-label fw-semibold">Contact No.:</label>
                    <input class="form-control" type="text" v-model="form.contact_number"
                        placeholder="Enter contact number...">
                </div>
                <div class="col-12 col-sm-6">
                    <label class="form-label fw-semibold">Stag Registry No.:</label>
                    <input class="form-control" type="text" v-model="form.stag_number"
                        placeholder="Enter stag registry number...">
                </div>
            </div>
            <p v-if="errorMessage" class="text-danger small mb-2">{{ errorMessage }}</p>
            <div class="d-flex justify-content-end gap-2 mt-3">
                <button class="btn btn-secondary" @click="closeModal()">Cancel</button>
                <button class="btn btn-success" @click="goTo()">Submit</button>
            </div>
        </b-modal>

        <!-- Import Modal -->
        <b-modal v-model="importModal" centered title="Import Wingband" title-class="font-18" hide-footer size="xl">
            <div>
                <label class="form-label">Select File:</label>
                <input class="form-control w-100" type="file" @change="handleFileUpload" accept=".xls,.xlsx"
                    ref="fileInput">
                <p v-if="errorMessage" class="error">{{ errorMessage }}</p>
                <div class="mt-2">
                    <button class="btn btn-sm btn-outline-secondary" type="button" @click="showChapterHint = !showChapterHint">
                        <i class='bx bx-info-circle'></i> {{ showChapterHint ? 'Hide' : 'Show' }} Valid Chapters
                    </button>
                    <div v-if="showChapterHint" class="mt-2 border rounded p-2" style="max-height: 150px; overflow-y: auto; background: #f8f9fa;">
                        <small class="text-muted d-block mb-1 fw-semibold">Valid chapter names for import:</small>
                        <span v-for="c in chapters" :key="c.id" class="badge bg-light text-dark border me-1 mb-1 d-inline-block">{{ c.chapter }}</span>
                        <span v-if="chapters.length === 0" class="text-muted small">Loading chapters...</span>
                    </div>
                </div>
            </div>
            <div v-if="importErrors.length > 0" class="mt-3">
                <div class="alert alert-danger d-flex align-items-center mb-2" role="alert">
                    <i class="bx bx-error-circle fs-5 me-2"></i>
                    <div>
                        <strong>Import Failed.</strong> The uploaded file contains invalid data. Please correct the errors below and re-upload.
                    </div>
                </div>
                <div class="table-responsive" style="max-height: 350px; overflow-y: auto;">
                    <table class="table table-bordered table-sm mb-0">
                        <thead class="table-danger" style="position: sticky; top: 0; z-index: 1;">
                            <tr>
                                <th class="text-center" style="width: 60px;">Row</th>
                                <th style="width: 140px;">Column</th>
                                <th style="width: 120px;">Value</th>
                                <th>Error</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(err, i) in importErrors" :key="i">
                                <td class="text-center fw-bold text-danger">{{ err.row }}</td>
                                <td class="fw-semibold">{{ err.column }}</td>
                                <td><span class="badge bg-secondary">{{ err.value }}</span></td>
                                <td class="text-danger small">{{ err.message }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="modal-footer mt-3 pb-0">
                <div class="d-flex justify-content-end align-items-center w-100">
                    <button class="btn btn-secondary text-white mx-1" @click="closeModal()">Cancel</button>
                    <button class="btn btn-success text-white mx-1" :disabled="isImporting" @click="importExcel()">
                        <span v-if="isImporting">Importing...</span>
                        <span v-else>Import Excel</span>
                    </button>
                </div>
            </div>
        </b-modal>
    </Layout>
</template>

<style scoped>
.act-btn {
    cursor: pointer;
    min-height: 90px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    transition: opacity 0.2s;
}
.act-btn:hover {
    opacity: 0.9;
}
</style>

<style>
.modal-almost-fullscreen {
    max-width: 95vw !important;
    width: 95vw !important;
    margin: 2.5vh auto !important;
}
.modal-almost-fullscreen .modal-content {
    min-height: 90vh;
}
</style>
